import Accordion from "components/accordion/Accordion";
import DailyReportCard from "components/card/DailyReportCard";
import { CreateAppealRequestPopup } from "components/pop-up/AppealRequest";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AssetAppeal, Report } from "types";

export default function ReportList({
  appealId,
  fileRowProps,
  reports,
  recoveryReports,
  appeal,
}: {
  appealId?: string;
  fileRowProps: any;
  reports: Report[];
  recoveryReports: Report[];
  appeal?: AssetAppeal;
}) {
  const { t } = useTranslation();

  // Filter reports by type
  const appealDailyReports = reports?.filter(
    (report) => !report.is_next_appointment_reason_final_verdict,
  );
  const appealFinalVerdicts = reports?.filter(
    (report) => report.is_next_appointment_reason_final_verdict,
  );

  const [isAppealPopupOpen, setIsAppealPopupOpen] = useState<{
    open: boolean;
    data: any;
  }>({ open: false, data: null });

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString(undefined, {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div className="max-w-3xl bg-gray-50 rounded-xl shadow-sm w-[55%] p-2 mt-2">
      <div className="space-y-2">
        {/* Appeal Daily Reports */}
        {appealDailyReports?.length > 0 && (
          <Accordion
            title={`${t("appeal_daily_reports")} (${appealDailyReports?.length})`}
            mainTitle=""
          >
            <div className="space-y-2">
              {appealDailyReports.map((report, index) => (
                <Accordion
                  key={report.id}
                  title={`${t("daily_report")} - ${formatDate(report.court_hearing_date)}`}
                  mainTitle=""
                >
                  <DailyReportCard
                    key={report.id || index}
                    report={report}
                    fileRowProps={fileRowProps}
                    prohibitionId={report.prohabition_request}
                  />
                </Accordion>
              ))}
            </div>
          </Accordion>
        )}

        {/* Appeal Final Verdicts */}
        {appealFinalVerdicts?.length > 0 && (
          <Accordion
            title={`${t("appeal_final_verdicts")} (${appealFinalVerdicts?.length})`}
            mainTitle=""
          >
            <div className="space-y-2">
              {appealFinalVerdicts.map((report, index) => (
                <Accordion
                  key={report.id}
                  title={`${t("final_verdict")} - ${formatDate(report.court_decision_date as string)}`}
                  mainTitle=""
                >
                  <DailyReportCard
                    key={report.id || index}
                    report={report}
                    fileRowProps={fileRowProps}
                    isAppeal={true}
                    setIsAppealPopupOpen={setIsAppealPopupOpen}
                    appealId={appealId}
                    appeal={appeal}
                    prohibitionId={report.prohabition_request}
                  />
                </Accordion>
              ))}
            </div>
          </Accordion>
        )}

        {/* No Reports Message */}
        {reports?.length === 0 && recoveryReports.length === 0 && (
          <p>{t("no_reports_added")}</p>
        )}
      </div>
      <CreateAppealRequestPopup
        referralId={appeal?.asset_referral?.id as string}
        data={isAppealPopupOpen.data}
        isOpen={isAppealPopupOpen.open}
        onClose={() => setIsAppealPopupOpen({ open: false, data: null })}
      />
    </div>
  );
}
